'use client'

import React, { useEffect, useRef, useState } from 'react'
import './style.css';
import formatMsg from '../../util/formatMsg';
import styles from './style.module.css'
import Helper from '../../util/helper';
import { BookingPopoverOptions, BookingSummary, RecurringAutopayInfo, getItem, LinkWrapper, NewBookingStatuses, packageActions, PrefixIconButton, RescheduleBookingModal, BookSlotsModal, SpinWrapper, TermsAndConditions, timeutil } from '../..';
import { Affix, Col, Row, Skeleton, Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { ModalWrapper } from '../wrapperComponents/page';

const { changeBookingStatus, resetOperationType } = packageActions;
function page(props) {
    const { firebase, payload, entityType, isLoading } = props;
    const dispatch = useDispatch();
    const { accountReducer, packageReducer } = Helper.getSelectorState(['accountReducer', 'packageReducer']);
    const [accountsMap, setAccountsMap] = useState(new Map());
    const [openRescheduleModal, setOpenRescheduleModal] = useState(false);
    const [openDateModal, setOpenDateModal] = useState(false);
    const [afterCancel, setAfterCancel] = useState(false);
    const [beforeCancel, setBeforeCancel] = useState(false);
    const [termsVisible, setTermsVisible] = useState(false);
    const [descriptionAffixed, setDescriptionAffixed] = useState(false)
    const [activeModal, setActiveModal] = useState(null);
    const [rescheduleModal, setRescheduleModal] = useState(false);
    const isAccount = Helper.isAccount(firebase);
    const validUpcomingMembershipStatues = useRef(Helper.getValidUpcomingMembershipStatues());

    useEffect(() => {

        const newAccountsMap = new Map();
        Helper.getAccountList(firebase).forEach((accountObj) => {
            newAccountsMap.set(accountObj.id, accountObj);
        });
        setAccountsMap(newAccountsMap);

    }, [accountReducer.accountList]);

    useEffect(() => {
        if (packageReducer.operationType === "BOOKING_UPDATED") {
            dispatch(resetOperationType(null));
            isAccount && setAfterCancel(true);
        }
    }, [packageReducer.operationType]);

    const formatTime = (epoch: number) => timeutil.getInstance(epoch).format("h:mm A");
    const packageRedirectUrl = isAccount ? `/dashboard/packageDetailView?id=${payload?.id}&centerId=` + (getItem("centerId") || Helper.getUrlParam("centerId")) : `/dashboard/package/packageDetailedView?id=${payload?.id}`;

    const renderCancellation = payload?.cancellationRules && payload?.cancellationRules?.allow
    const renderReschedule = payload?.reschedulingRules && payload?.reschedulingRules?.allow
    const renderTermsAndConditions = payload?.acknowledgmentDetails?.termsAndConditions && Helper.stripHtmlTags(payload?.acknowledgmentDetails?.termsAndConditions)

    // Helper function to extract total credits from credits object (can be number or object with totalCredits)
    const getTotalCredits = (credits: any): number => {
        const pricePack = payload?.priceDetails?.pricePack;

        // For CUSTOM with DURATION: totalCredits = noOfClasses * totalCredits (from credits object)
        if (pricePack?.frequency === "CUSTOM" && pricePack?.durationType === "DURATION") {
            const noOfClasses = pricePack?.noOfClasses || 0;
            let creditsTotalCredits = 0;

            // Extract totalCredits from credits object
            if (typeof credits === 'object' && credits !== null && credits.totalCredits !== undefined) {
                creditsTotalCredits = credits.totalCredits;
            } else if (typeof credits === 'number') {
                creditsTotalCredits = credits;
            }

            if (noOfClasses > 0 && creditsTotalCredits > 0) {
                return noOfClasses * creditsTotalCredits;
            }
        }

        // For normal price pack: if credits object has totalCredits and perPeriod, calculate as totalCredits * perPeriod
        if (typeof credits === 'object' && credits !== null) {
            if (credits.totalCredits !== undefined && credits.perPeriod !== undefined) {
                return credits.totalCredits * credits.perPeriod;
            }
            if (credits.totalCredits !== undefined) {
                return credits.totalCredits;
            }
        }

        // Fallback: return as number or 0
        return typeof credits === 'number' ? credits : 0;
    };

    // Helper function to calculate total booked credits from bookedCredits array
    const getBookedCreditsTotal = (bookedCredits: any[]): number => {
        if (!Array.isArray(bookedCredits)) return 0;
        return bookedCredits.reduce((sum, entry) => sum + (entry.creditsUsed || 0), 0);
    };

    // Helper function to format frequency/duration display
    const getFrequencyDurationDisplay = (): string => {
        const frequency = payload?.priceDetails?.pricePack?.frequency;
        const isCustomOrEntire = frequency === "CUSTOM" || frequency === "ENTIRE_PACKAGE_DURATION";

        // Get duration value
        const duration = isCustomOrEntire
            ? (payload?.bookedSlots?.totalRunningDays || 0)
            : (payload?.bookingBasicDetails?.pricePackDuration || 0);

        // Get frequency label
        const frequencyLabel = isCustomOrEntire ? "DAILY" : (frequency || "");

        // Pluralize if needed
        const pluralSuffix = duration > 1 ? "S" : "";
        const formattedFrequency = formatMsg(frequencyLabel + pluralSuffix);

        // Return formatted string, ensuring no null values
        return ` (${duration} ${formattedFrequency})`;
    };

    const totalCredits = getTotalCredits(payload?.credits);
    const bookedCreditsTotal = getBookedCreditsTotal(payload?.bookedCredits || []);
    const remainingCredits = totalCredits - bookedCreditsTotal;
    const bookedSlotsCount = payload?.bookedSlotsLength ?? bookedCreditsTotal;
    function membershipHasCreditsLeft() {
        return payload?.priceDetails?.pricePack?.unlimitedClasses ||
            remainingCredits > 0;
    }

    function getDateColorHex(date) {
        const today = timeutil.getInstance();
        const targetDate = timeutil.getInstance(date);

        if (!targetDate.isAfter(today, 'day')) {
            return '#000000';
        }

        const diffDays = targetDate.diff(today, 'days');

        switch (true) {
            case (diffDays <= 5):
                return '#FF0000';
            case (diffDays <= 15):
                return '#E56C32';
            default:
                return '#000000';
        }
    }

    function getMembershipMainDates() {

        const { label, date } = Helper.getMembershipMainDatesText(payload);
        const color = getDateColorHex(date);
        return (
            <div className='bdc-data-container' style={{ color: color }}>
                <div className='bdc-data-label'>
                    {formatMsg(label)}:
                </div>
                <div className='bdc-data-value'>
                    {timeutil.getInstance(date).format(Helper.dateFormat(firebase))}
                </div>
            </div>
        )
    }

    function renderBookingIdStatus() {
        const isMobileAffixed = typeof window !== 'undefined' && window.innerWidth <= 671 && descriptionAffixed;
        const bookingStatusObj = Helper.getBookingStatusStyleObj(payload?.bookingBasicDetails?.status || "pending");
        return (
            <Affix offsetTop={52} onChange={e => setDescriptionAffixed(e)} className='bdc-booking-affix'>
                <div
                    className={styles.bookingIdContainer}
                    style={
                        isMobileAffixed
                            ? {
                                background: bookingStatusObj.backgroundColor,
                                border: 'none',
                                borderRadius: '0px',
                                boxShadow: '0px 4px 8px 0px #00000029',
                                padding: '16px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px',
                            }
                            : {
                                border: descriptionAffixed ? 'none' : undefined,
                                borderRadius: descriptionAffixed ? '0px' : undefined,
                                boxShadow: descriptionAffixed ? '0px 4px 8px 0px #00000029' : undefined
                            }
                    }
                >
                    {!isLoading ? (
                        isMobileAffixed ? (
                            <>
                                <div className="affixed-header-row">
                                    <div className="affixed-status-row">
                                        <img src={bookingStatusObj.imgSrc} alt="booking-status" className="affixed-status-icon" />
                                        <span className="affixed-status-text" style={{ color: bookingStatusObj.txtColor }}>
                                            {formatMsg(payload?.bookingBasicDetails?.status || "active")}
                                        </span>
                                    </div>
                                    <BookingPopoverOptions
                                        record={payload?.bookingBasicDetails}
                                        payload={payload}
                                        firebase={firebase}
                                        setBeforeCancel={setBeforeCancel}
                                        setOpenRescheduleModal={setOpenRescheduleModal}
                                        membershipCheck={!(entityType === "membership") || (entityType === "membership" && remainingCredits > 0)}
                                    />
                                </div>
                                <div className="affixed-details-row">
                                    <span>{formatMsg("bookingId") + " : "}<span className="affixed-details-bold">{payload?.bookingBasicDetails?.bookingNumber}</span></span>
                                    <span>{formatMsg("date") + " : "}<span className="affixed-details-bold">{timeutil.getInstance(payload?.bookingBasicDetails?.createdOn || payload?.bookingBasicDetails?.updatedOn).format(Helper.dateFormat(firebase))}</span></span>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className={styles.bookingIdSubContainer}>
                                    <div className={styles.title}>
                                        {formatMsg("bookingId")}
                                        <span style={{ margin: "0px 12px" }}>:</span>
                                        <span style={{ fontWeight: 700 }}>{payload?.bookingBasicDetails?.bookingNumber}</span>
                                    </div>
                                    <div className={styles.title}>
                                        {formatMsg("date")}
                                        <span className={styles.marginInlineStart}>:</span>
                                        <span style={{ fontWeight: 700 }}>{timeutil.getInstance(payload?.bookingBasicDetails?.createdOn || payload?.bookingBasicDetails?.updatedOn).format(Helper.dateFormat(firebase))}</span>
                                    </div>

                                </div>

                                <div className={styles.bookingIdStatusContainer}>
                                    <div className={styles.mbView}>
                                        {Helper.getBookingStatus(payload?.bookingBasicDetails?.status || "pending")}
                                    </div>

                                    <BookingPopoverOptions
                                        record={payload?.bookingBasicDetails}
                                        payload={payload}
                                        firebase={firebase}
                                        setBeforeCancel={setBeforeCancel}
                                        setOpenRescheduleModal={setOpenRescheduleModal}
                                        membershipCheck={!(entityType === "membership") || (entityType === "membership" && remainingCredits > 0)}
                                    />
                                </div>
                            </>
                        )
                    ) : (
                        <Skeleton active paragraph={{ rows: 2 }} />
                    )}
                </div>
            </Affix >
        )
    }
    function renderMembershipBasicDetails() {
        const isEnabled = membershipHasCreditsLeft() && payload?.pricePackFrequency !== "ENTIRE_PACKAGE_DURATION" && Helper.entityHasValidStatus(validUpcomingMembershipStatues.current, payload?.bookingBasicDetails?.status);
        const isDisplay = payload?.bookingBasicDetails?.status != NewBookingStatuses.CONFIRMATION_PENDING && payload?.bookingBasicDetails?.status != NewBookingStatuses.WAITLISTED && payload?.pricePackFrequency !== "ENTIRE_PACKAGE_DURATION";

        return (
            <div className='bdc-book-pkg-card bdc-book-pkg-card-fixed'>
                {!isLoading ?
                    <>
                        <div className='bdc-book-detail-container'>
                            <div className='bdc-book-detail-subcontainer1'>
                                <div className='bdc-package-name-box'>
                                    <div className='bdc-package-name-box' style={{ justifyContent: "none" }}>
                                        <div className='bdc-book-package-name'>{payload?.name} </div>
                                        <LinkWrapper href={packageRedirectUrl} >
                                            <img src="/images/purpleRedirect.png" className='bdc-booking-redirect-icon' alt="redirect" />
                                        </LinkWrapper>
                                    </div>
                                    <div
                                        className={styles.membershipBox}
                                    >
                                        {formatMsg("membership")}
                                    </div>
                                </div>

                                <div className='bdc-book-package-date'>
                                    {payload?.bookedBatch?.name}
                                </div>
                            </div>
                            <div className='bdc-book-detail-subcontainer1'>

                                {
                                    !isAccount && remainingCredits > 0 &&
                                    <LinkWrapper href={`/dashboard/accounts/accountDetailView?id=${accountsMap?.get(payload?.bookingBasicDetails?.accountId)?.id}&entityType=account`} target="_blank" style={{ display: 'contents' }}>
                                        <div className='global-flex-wrap bdc-book-user' style={{ rowGap: 8 }}>
                                            <img src="/images/singleUserLight.png" className='bdc-booking-header-icons' />
                                            <span className="bdc-participant-tag">
                                                <img style={{ height: 15, width: 15, borderRadius: "50%" }} src={Helper.getProfileImageUrl(accountsMap?.get(payload?.bookingBasicDetails?.accountId))} />
                                                <span>{accountsMap?.get(payload?.bookingBasicDetails?.accountId)?.name}</span>
                                            </span>
                                        </div>
                                    </LinkWrapper>
                                }

                                {
                                    remainingCredits > 0 &&
                                    (!isAccount ? (
                                        <LinkWrapper href={`/dashboard/users/userDetailView?id=${payload?.bookingBasicDetails?.bookedForUserId}&entityType=user`} target="_blank" style={{ display: 'contents' }}>
                                            <div className='global-flex-wrap bdc-book-user' style={{ rowGap: 8 }}>
                                                <img src="/images/participants.png" className='bdc-booking-header-icons' />
                                                <span className="bdc-participant-tag">
                                                    <img style={{ height: 15, width: 15, borderRadius: "50%" }} src="/images/NoPhoto.png" />
                                                    <span>{payload?.bookingBasicDetails?.bookedForUser}</span>
                                                </span>
                                            </div>
                                        </LinkWrapper>
                                    ) : (
                                        <div className='global-flex-wrap bdc-book-user' style={{ rowGap: 8 }}>
                                            <img src="/images/participants.png" className='bdc-booking-header-icons' />
                                            <span className="bdc-participant-tag">
                                                <img style={{ height: 15, width: 15, borderRadius: "50%" }} src="/images/NoPhoto.png" />
                                                <span>{payload?.bookingBasicDetails?.bookedForUser}</span>
                                            </span>
                                        </div>
                                    ))
                                }

                                <div className="global-flex bdc-center-time-pricepack">
                                    <img src="/images/membershipCalender.png" className='bdc-booking-header-icons' />
                                    <div>
                                        {payload?.priceDetails?.pricePack?.unlimitedClasses ? (
                                            // An unlimited pack records no credits, so count the booked slots instead.
                                            `${bookedSlotsCount} ${bookedSlotsCount === 1 ? (formatMsg("class") || "class") : (formatMsg("classes") || "classes")} ${formatMsg("booked") || "booked"}`
                                        ) : (
                                            formatMsg("creditsBookedRemainingDesc",
                                                {
                                                    bookedCredits: bookedCreditsTotal,
                                                    totalCredit: totalCredits,
                                                    remainingCredits: remainingCredits
                                                })
                                        )}
                                    </div>
                                </div>

                                {
                                    remainingCredits === 0 &&
                                    <div className="global-flex bdc-center-time-pricepack">
                                        <img src="/images/Calendar.png" className='bdc-booking-header-icons' />
                                        {getMembershipMainDates()}
                                    </div>
                                }

                                {
                                    remainingCredits > 0 && payload?.bookedSlots?.startEndDateAndTime?.startDate && payload?.bookedSlots?.startEndDateAndTime?.endDate &&
                                    <div className='bdc-center-time-pricepack'>
                                        <div className='global-display-flex-between-wrap bdc-center-time-pricepack' style={{ columnGap: 20, rowGap: 6, justifyContent: "flex-start" }}>

                                            <div>
                                                <img src="/images/Calendar.png" className='bdc-booking-header-icons' />
                                                <>
                                                    <span>
                                                        {
                                                            timeutil.inFormat(payload?.bookedSlots?.startEndDateAndTime?.startDate, Helper.dateFormat(firebase)) +
                                                            " - " +
                                                            timeutil.inFormat(payload?.bookedSlots?.startEndDateAndTime?.endDate, Helper.dateFormat(firebase))
                                                        }
                                                    </span>
                                                    &nbsp;
                                                    {/* <span className='booking-frequency'
                                                        onClick={() => {
                                                            setActiveModal("dates")
                                                            setOpenDateModal(payload?.bookingBasicDetails?.id);
                                                        }}>
                                                        {getFrequencyDurationDisplay()}
                                                    </span> */}
                                                </>
                                            </div>

                                            <div className='global-flex bdc-center-time-pricepack'>
                                                <img src="/images/bookingClock.png" className='bdc-booking-header-icons' />
                                                {payload?.bookedSlots?.uniqueTimeSlotsObjList?.length > 1
                                                    ?
                                                    <span className='booking-frequency'
                                                        onClick={() => {
                                                            setActiveModal("timings")
                                                            setOpenDateModal(payload?.bookingBasicDetails?.id);
                                                        }}>
                                                        {formatMsg("multipleTimings")}
                                                        {payload?.bookingBasicDetails?.activities?.length > 0
                                                            ? ` (${payload.bookingBasicDetails.activities.length} ${formatMsg("small.activities")})`
                                                            : ''}
                                                    </span>
                                                    :
                                                    payload?.bookedSlots?.uniqueTimeSlotsObjList?.map((slot, idx) => {

                                                        const startTimeFormatted = formatTime(slot.startTime);
                                                        const endTimeFormatted = formatTime(slot.endTime);
                                                        return (
                                                            <span key={idx}>
                                                                {startTimeFormatted} - {endTimeFormatted}
                                                                {idx < payload?.bookedSlots?.uniqueTimeSlotsObjList.length - 1 && ", "}
                                                            </span>
                                                        );
                                                    })}
                                            </div>
                                        </div>
                                    </div>
                                }

                                <div className="global-flex bdc-center-time-pricepack">
                                    <img src="/images/newLocationPin.png" className="bdc-booking-header-icons" alt="Location" />
                                    {(() => {
                                        const record = payload?.bookedInCenter;
                                        if (!record) return null;
                                        const address = [record.name, record.addressMainLine, record.roadArea, record.townCity, record.state, record.country + (record.pincode ? ` - ${record.pincode}` : '')]
                                            .filter(Boolean).join(', ');
                                        return (
                                            <div>
                                                <Tooltip title={address}>
                                                    {address.length < 80 ? address : address.slice(0, 80) + '...'}
                                                </Tooltip>
                                            </div>
                                        );
                                    })()}
                                </div>

                                {
                                    payload?.priceDetails?.pricePack &&
                                    <div className='global-flex bdc-center-time-pricepack'>
                                        <img src="/images/pricePack.png" className='bdc-booking-header-icons' />
                                        <span>{Helper.getPricingPackName3(payload?.priceDetails?.pricePack, firebase)}</span>
                                    </div>
                                }

                            </div>

                            {isDisplay &&
                                <div>
                                    <PrefixIconButton
                                        type={"primary"}
                                        title={
                                            isEnabled
                                                ? formatMsg("bookSlots")
                                                : formatMsg("ended")
                                        }
                                        borderRadius="8px"
                                        onClick={() => {
                                            if (isEnabled) {
                                                setRescheduleModal(payload?.bookingBasicDetails?.id);
                                            }
                                        }}
                                        disabled={!isEnabled}
                                        backgroundColor={isEnabled ? "#7413BD" : "#D0D0D0"}
                                        height="40px"
                                    />
                                </div>
                            }
                        </div>

                        <img className='bdc-booking-cover-photo' src={payload?.coverPhoto} />
                    </>
                    :
                    <Skeleton active paragraph={{ rows: 4 }} />
                }
            </div >
        )
    }
    function renderBookingBasicDetails() {
        return (
            <div className='bdc-book-pkg-card bdc-book-pkg-card-fixed'>
                {!isLoading ?
                    <>
                        <div className='bdc-book-detail-container'>
                            <div className='bdc-book-detail-subcontainer1'>
                                <div className='bdc-package-name-box'>
                                    <div className='bdc-package-name-box' style={{ justifyContent: "none" }}>
                                        <div className='bdc-book-package-name'>{payload?.name} </div>
                                        <LinkWrapper href={packageRedirectUrl} >
                                            <img src="/images/purpleRedirect.png" className='bdc-booking-redirect-icon' alt="redirect" />
                                        </LinkWrapper>
                                    </div>
                                </div>

                                <div className='bdc-book-package-date'>
                                    {payload?.bookedBatch?.name}
                                </div>
                            </div>
                            <div className='bdc-book-detail-subcontainer1'>

                                {
                                    !isAccount &&
                                    <LinkWrapper href={`/dashboard/accounts/accountDetailView?id=${accountsMap?.get(payload?.bookingBasicDetails?.accountId)?.id}&entityType=account`} target="_blank" style={{ display: 'contents' }}>
                                        <div className='global-flex-wrap bdc-book-user' style={{ rowGap: 8 }}>
                                            <img src="/images/singleUserLight.png" className='bdc-booking-header-icons' />
                                            <span className="bdc-participant-tag">
                                                <img style={{ height: 15, width: 15, borderRadius: "50%" }} src={Helper.getProfileImageUrl(accountsMap?.get(payload?.bookingBasicDetails?.accountId))} />
                                                <span>{accountsMap?.get(payload?.bookingBasicDetails?.accountId)?.name}</span>
                                            </span>
                                        </div>
                                    </LinkWrapper>
                                }

                                {!isAccount ? (
                                    <LinkWrapper href={`/dashboard/users/userDetailView?id=${payload?.bookingBasicDetails?.bookedForUserId}&entityType=user`} target="_blank" style={{ display: 'contents' }}>
                                        <div className='global-flex-wrap bdc-book-user' style={{ rowGap: 8 }}>
                                            <img src="/images/participants.png" className='bdc-booking-header-icons' />
                                            <span className="bdc-participant-tag">
                                                <img style={{ height: 15, width: 15, borderRadius: "50%" }} src="/images/NoPhoto.png" />
                                                <span>{payload?.bookingBasicDetails?.bookedForUser}</span>
                                            </span>
                                        </div>
                                    </LinkWrapper>
                                ) : (
                                    <div className='global-flex-wrap bdc-book-user' style={{ rowGap: 8 }}>
                                        <img src="/images/participants.png" className='bdc-booking-header-icons' />
                                        <span className="bdc-participant-tag">
                                            <img style={{ height: 15, width: 15, borderRadius: "50%" }} src="/images/NoPhoto.png" />
                                            <span>{payload?.bookingBasicDetails?.bookedForUser}</span>
                                        </span>
                                    </div>
                                )}

                                <div className='bdc-center-time-pricepack'>
                                    <div className='global-display-flex-between-wrap bdc-center-time-pricepack' style={{ columnGap: 20, rowGap: 6, justifyContent: "flex-start" }}>

                                        <div className='global-flex'>
                                            <img src="/images/Calendar.png" className='bdc-booking-header-icons' />
                                            <>
                                                <span>
                                                    {
                                                        timeutil.inFormat(payload?.bookedSlots?.startEndDateAndTime?.startDate, Helper.dateFormat(firebase)) +
                                                        " - " +
                                                        timeutil.inFormat(payload?.bookedSlots?.startEndDateAndTime?.endDate, Helper.dateFormat(firebase))
                                                    }
                                                </span>
                                                &nbsp;
                                                <span className='booking-frequency'
                                                    onClick={() => {
                                                        setActiveModal("dates")
                                                        setOpenDateModal(payload?.bookingBasicDetails?.id);
                                                    }}>
                                                    {
                                                        (" (" +
                                                            (payload?.priceDetails?.pricePack?.frequency === "CUSTOM" || payload?.priceDetails?.pricePack?.frequency === "ENTIRE_PACKAGE_DURATION" ? payload?.bookedSlots?.totalRunningDays : (payload?.bookingBasicDetails?.pricePackDuration || 0)) + " " +
                                                            formatMsg(((payload?.priceDetails?.pricePack?.frequency === "CUSTOM" || payload?.priceDetails?.pricePack?.frequency === "ENTIRE_PACKAGE_DURATION") ?
                                                                "DAILY" : payload?.priceDetails?.pricePack?.frequency) + ((payload?.priceDetails?.pricePack?.frequency === "CUSTOM" || payload?.priceDetails?.pricePack?.frequency === "ENTIRE_PACKAGE_DURATION" ? payload?.bookedSlots?.totalRunningDays : payload?.bookingBasicDetails?.pricePackDuration) > 1 ? "S" : "")) + ")"
                                                        )
                                                    }
                                                </span>
                                            </>
                                        </div>
                                        <div className='global-flex bdc-center-time-pricepack'>
                                            <img src="/images/bookingClock.png" className='bdc-booking-header-icons' />
                                            {payload?.bookedSlots?.uniqueTimeSlotsObjList?.length > 1
                                                ?
                                                <span className='booking-frequency'
                                                    onClick={() => {
                                                        setActiveModal("timings")
                                                        setOpenDateModal(payload?.bookingBasicDetails?.id);
                                                    }}>
                                                    {formatMsg("multipleTimings")}
                                                    {firebase.schoolConfig.showPackageActivities && payload?.bookingBasicDetails?.activities?.length > 0
                                                        ? ` (${payload.bookingBasicDetails.activities.length} ${formatMsg("small.activities")})`
                                                        : ''}
                                                </span>
                                                :
                                                payload?.bookedSlots?.uniqueTimeSlotsObjList?.map((slot, idx) => {

                                                    const startTimeFormatted = formatTime(slot.startTime);
                                                    const endTimeFormatted = formatTime(slot.endTime);
                                                    return (
                                                        <span key={idx}>
                                                            {startTimeFormatted} - {endTimeFormatted}
                                                            {idx < payload?.bookedSlots?.uniqueTimeSlotsObjList.length - 1 && ", "}
                                                        </span>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                </div>

                                <div className="global-flex bdc-center-time-pricepack">
                                    <img src="/images/newLocationPin.png" className="bdc-booking-header-icons" alt="Location" />
                                    {(() => {
                                        const record = payload?.bookedInCenter;
                                        if (!record) return null;
                                        const address = [record.name, record.addressMainLine, record.roadArea, record.townCity, record.state, record.country + (record.pincode ? ` - ${record.pincode}` : '')]
                                            .filter(Boolean).join(', ');
                                        return (
                                            <div>
                                                <Tooltip title={address}>
                                                    {address.length < 80 ? address : address.slice(0, 80) + '...'}
                                                </Tooltip>
                                            </div>
                                        );
                                    })()}
                                </div>

                                {
                                    payload?.priceDetails?.pricePack &&
                                    <div className='global-flex bdc-center-time-pricepack'>
                                        <img src="/images/pricePack.png" className='bdc-booking-header-icons' />
                                        <span>{Helper.getPricingPackName3(payload?.priceDetails?.pricePack, firebase)}</span>
                                    </div>
                                }

                            </div>
                        </div>

                        <img className='bdc-booking-cover-photo' src={payload?.coverPhoto} />
                    </>
                    :
                    <Skeleton active paragraph={{ rows: 4 }} />
                }
            </div >
        )
    }
    function renderAdditionalDetails() {
        if (!payload?.additionalFieldSections || payload.additionalFieldSections.length === 0) {
            return null;
        }

        return (
            <div className='bdc-mobile-view-padding'>
                {payload.additionalFieldSections.map((section, sectionIndex) => {
                    if (!section.additionalFields || section.additionalFields.length === 0) return null;

                    return (
                        <div key={section.id || sectionIndex} className='bdc-book-additional-card bdc-book-additional-card-fixed' style={{ marginBottom: sectionIndex < payload.additionalFieldSections.length - 1 ? 16 : 0 }}>
                            {!isLoading ?
                                <>
                                    <div className='bdc-book-package-name' style={{ padding: "16px 16px 8px 16px" }}>
                                        {section.sectionHeading || formatMsg("additionaldetails")}
                                    </div>
                                    <div className='bdc-divider' />
                                    <Row gutter={[16, 16]} className='bdc-additionalDetail-container'>
                                        {section.additionalFields.map((item, idx) => {
                                            return (
                                                <Col lg={8} md={12} sm={24} xs={24} key={idx}>
                                                    <div className='additional-field-cont'>
                                                        <div className='additionalDetail-header'>
                                                            {item.name}
                                                        </div>
                                                        <div className='additionalDetail-header-value'>
                                                            {Helper.getFieldValueByDatatype(item, firebase)}
                                                        </div>
                                                    </div>
                                                </Col>
                                            )
                                        })}
                                    </Row>
                                </>
                                :
                                <Skeleton active paragraph={{ rows: 4 }} style={{ padding: "16px" }} />
                            }
                        </div>
                    );
                })}
            </div>
        );
    }

    function getButtonGroup() {
        return (
            <div>
                {
                    afterCancel &&
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                        <PrefixIconButton
                            title={formatMsg("close")}
                            onClick={() => {
                                setAfterCancel(false)
                            }}
                            borderRadius={"4px"}
                            type={"primary"}
                        />
                    </div>}

                {
                    beforeCancel &&
                    <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>
                        <PrefixIconButton
                            title={formatMsg("goBack")}
                            border={true}
                            onClick={() => setBeforeCancel(false)}
                            borderRadius={"4px"}
                        />
                        <PrefixIconButton
                            title={formatMsg("yesCancel")}
                            onClick={() => {
                                dispatch(changeBookingStatus({ firebase, record: payload, confirmOrNot: false }));
                                setBeforeCancel(false);
                            }}
                            borderRadius={"4px"}
                            type={"primary"}
                        />
                    </div>

                }
            </div>
        )
    }

    function isEntityStatusConfimationPending() {
        return payload?.bookingBasicDetails?.status === 'CONFIRMATION_PENDING';
    }


    const getRefundPolicy = (cancellationRules, bookingStartDate) => {
        const currentTime = timeutil.getInstance();
        const timeDifference = timeutil.getInstance(bookingStartDate).diff(currentTime, "hours");

        let refundPercentage = 0;
        cancellationRules.refundDetails.forEach((rule) => {
            let ruleTime = rule.type === "days" ? rule.value * 24 : rule.value;
            if (timeDifference >= ruleTime) {
                refundPercentage = Math.max(refundPercentage, rule.percentage);
            }
        });
        return formatMsg('youWillReceiveA') + " " + refundPercentage + "% " + formatMsg("refund");
    };

    const getCancellationNotice = (cancellationRules) => {
        return formatMsg('cancelAtLeast') + " " + cancellationRules.duration + cancellationRules.durationType + " " + formatMsg("inAdvanceToAvoidCharges");
        // return `Cancel at least ${cancellationRules.duration} ${cancellationRules.durationType} in advance to avoid charges.`;
    };

    return (
        <SpinWrapper spinning={packageReducer.isLoading}>
            <div className={styles.container}>
                <div className={styles.leftContainer}>
                    <div className={styles.bookingStatusVisiblity}>
                        {Helper.getBookingStatus(payload?.bookingBasicDetails?.status || "pending")}
                    </div>

                    <div className={descriptionAffixed ? '' : 'bdc-mobile-view-padding'}>
                        {
                            renderBookingIdStatus()
                        }
                    </div>
                    <div className='bdc-mobile-view-padding'>
                        {
                            entityType === "membership"
                                ? renderMembershipBasicDetails()
                                : renderBookingBasicDetails()
                        }
                    </div>

                    {
                        renderAdditionalDetails()
                    }

                    <div className='bdc-mobile-view-padding'>
                        {!isLoading ?
                            <>
                                <TermsAndConditions
                                    payload={payload}
                                    renderCancellation={renderCancellation}
                                    renderReschedule={renderReschedule}
                                    renderTermsAndConditions={renderTermsAndConditions}
                                    termsVisible={termsVisible}
                                    setTermsVisible={setTermsVisible}
                                />
                            </>
                            :
                            <div className='tnc-main-card '>
                                <Skeleton active paragraph={{ rows: 4 }} style={{ padding: "16px" }} />
                            </div>
                        }
                    </div>
                </div>
                <div className={styles.rightContainer}>
                    {!isLoading ?
                        <>
                            <BookingSummary
                                firebase={firebase}
                                participantCount={1}
                                pricePackDuration={payload?.bookingBasicDetails?.pricePackDuration}
                                slotsPerDay={payload?.bookingBasicDetails?.slotsPerDay}
                                priceDetails={payload?.priceDetails}
                                proratedAmount={payload?.bookingBasicDetails?.proratedAmount}
                                proratedDays={payload?.bookingBasicDetails?.proratedDays}
                                participantIndex={payload?.bookingBasicDetails?.participantIndex}
                                paymentStatus={payload?.invoiceObj?.invoiceStatus}
                                bookingGroupSize={payload?.bookingBasicDetails?.bookingGroupSize}
                                invoiceObj={payload?.invoiceObj}
                                centerId={payload?.bookingBasicDetails?.centerId}
                                bookingStatus={payload?.bookingBasicDetails?.status}
                            />
                            <RecurringAutopayInfo
                                accountId={payload?.bookingBasicDetails?.accountId}
                                bookingId={payload?.bookingBasicDetails?.id}
                                // Lets the panel tell a recurring booking from a one-off, so a
                                // family paying this one by hand can switch autopay on from here.
                                pricePack={payload?.priceDetails?.pricePack}
                            />
                        </>
                        :
                        <div className="bs-main-card">
                            <Skeleton active paragraph={{ rows: 6 }} style={{ padding: "16px" }} />
                        </div>
                    }
                </div>

                {open && (
                    <>
                        {openRescheduleModal && (
                            payload?.bookingBasicDetails?.isDeferred ? (
                                <BookSlotsModal
                                    open={openRescheduleModal}
                                    setOpen={setOpenRescheduleModal}
                                    totalClasses={totalCredits || 0}
                                    bookedClasses={payload?.bookedSlots?.slots || []}
                                    remainingCredits={remainingCredits}
                                    packageId={payload?.bookingBasicDetails?.packageId}
                                    bookingPeriod={payload?.bookingBasicDetails?.startDate && payload?.bookingBasicDetails?.endDate ? {
                                        startDate: payload.bookingBasicDetails.startDate,
                                        endDate: payload.bookingBasicDetails.endDate
                                    } : undefined}
                                />
                            ) : (
                                <RescheduleBookingModal
                                    open={openRescheduleModal}
                                    setOpen={setOpenRescheduleModal}
                                    packageId={payload?.bookingBasicDetails?.packageId}
                                />
                            )
                        )}

                        {openDateModal && (
                            <RescheduleBookingModal
                                open={openDateModal}
                                setOpen={setOpenDateModal}
                                readOnly
                                modalType={activeModal}
                                packageId={payload?.bookingBasicDetails?.packageId}
                            />
                        )}
                    </>
                )}
                {rescheduleModal ? (
                    payload?.bookingBasicDetails?.isDeferred ? (
                        <BookSlotsModal
                            open={rescheduleModal}
                            setOpen={setRescheduleModal}
                            totalClasses={totalCredits || 0}
                            bookedClasses={payload?.bookedSlots?.slots || []}
                            remainingCredits={remainingCredits}
                            packageId={payload?.bookingBasicDetails?.packageId}
                            bookingPeriod={payload?.bookingBasicDetails?.startDate && payload?.bookingBasicDetails?.endDate ? {
                                startDate: payload.bookingBasicDetails.startDate,
                                endDate: payload.bookingBasicDetails.endDate
                            } : undefined}
                        />
                    ) : (
                        <RescheduleBookingModal
                            open={rescheduleModal}
                            setOpen={setRescheduleModal}
                            remainingCredits={remainingCredits}
                            credits={payload?.credits}
                            packageId={payload?.bookingBasicDetails?.packageId}
                        />
                    )
                ) : null}
                <ModalWrapper
                    open={termsVisible}
                    title={<div style={{ color: "#7413bd" }}>{formatMsg("label.termsAndConditions")}</div>}
                    maskClosable={true}
                    width={600}
                    onCancel={() => setTermsVisible(false)}
                    footer={null}
                >
                    <div
                        className='bdc-tnc-text'
                        dangerouslySetInnerHTML={{ __html: payload?.acknowledgmentDetails?.termsAndConditions }}
                        style={{ whiteSpace: "normal" }}
                    />
                    {payload?.acknowledgmentDetails?.acknowledgmentFields &&
                        <>
                            <div className='bdc-book-package-name' style={{ padding: "16px 0px", borderTop: "1px solid #D0D0D0" }}>
                                {formatMsg("acknowledgement")}
                            </div>
                            <div className='tnc-ack-field-container'>
                                {payload?.acknowledgmentDetails?.acknowledgmentFields &&
                                    payload?.acknowledgmentDetails?.acknowledgmentFields.map((item, idx) => {
                                        return (
                                            <div key={idx} className='additional-field-cont' style={{ gap: "8px" }}>
                                                <div className='additionalDetail-header'>
                                                    {item.label}
                                                </div>

                                                <div className='additionalDetail-header-value'>
                                                    {Helper.getFieldValueByDatatype(item, firebase)}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </>
                    }

                </ModalWrapper>

                {
                    isAccount && afterCancel &&
                    <div >
                        <div className='pbm-cpo-overlay'>
                            <div className='pbm-cpo-popup'>
                                <p
                                    className='pbm-cpo-textAlignCenter fw-700'
                                    style={{ whiteSpace: "pre-wrap" }}>
                                    {formatMsg("afterCancel")}
                                </p>
                                <p className='pbm-cpo-textAlignLeft'>{formatMsg("desc.afterCancel")}</p>
                                <div>{getButtonGroup()}</div>
                            </div>
                        </div>
                    </div>
                }

                {
                    isAccount && beforeCancel &&
                    <div >
                        <div className='pbm-cpo-overlay'>
                            <div className='pbm-cpo-popup'>
                                <p
                                    className='pbm-cpo-textAlignCenter fw-700'
                                    style={{ whiteSpace: "pre-wrap" }}
                                >
                                    {formatMsg("beforeCancel")}
                                </p>
                                <div className='pbm-cpo-textAlignLeft mt-16'>
                                    {
                                        payload?.cancellationRules &&
                                        <div className='popup-refund'>
                                            {formatMsg("popup.refundPolicy") + ": " + getRefundPolicy(payload.cancellationRules, payload.bookingBasicDetails.startDate)}
                                        </div>
                                    }
                                    {
                                        payload?.cancellationRules &&
                                        <div>{formatMsg("cancellationNotice") + ": " + getCancellationNotice(payload?.cancellationRules)}
                                        </div>
                                    }
                                </div>
                                <div>{getButtonGroup()}</div>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div className='bdc-mobile-bottom-fill'></div>
        </SpinWrapper >
    )
}

export default page